import React from "react";
import { useNavigate } from "react-router-dom";
import { BiBuildingHouse } from "react-icons/bi";
import { Colors } from "../../assets/Colors";

// Menu induk General Affair. Isinya pintasan ke Akomodasi (denah room + penghuni)
// dan mini-app Akomodasi (HP) — otoritasnya sama dgn Operasional > Job Request
// (TOperationalMonitoring), jadi tanpa otoritas baru.
function MenuIconCard({ Icon, label, onClick }) {
  return (
    <div onClick={onClick} className="cursor-pointer">
      <div
        style={{ borderColor: Colors.primary }}
        className="flex flex-col items-center justify-center gap-2 border rounded-lg py-5 px-3 h-full text-center hover:shadow-md transition-shadow"
      >
        <Icon className="text-3xl" style={{ color: Colors.primary }} />
        <p className="text-sm font-medium text-gray-700">{label}</p>
      </div>
    </div>
  );
}

const GeneralAffairPage = () => {
  const navigate = useNavigate();
  const rawUser = JSON.parse(localStorage.getItem("user") || "null");
  const otoritas = rawUser?.Otoritas ?? {};

  return (
    <div className="md:ml-64">
      <div className="w-full flex flex-col items-center">
        <div className="w-full px-4 my-4">
          <div
            style={{ borderColor: Colors.primary }}
            className="flex flex-col border rounded"
          >
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full px-2 py-2">
              {otoritas.TOperationalMonitoring !== 0 && (
                <MenuIconCard
                  Icon={BiBuildingHouse}
                  label="Akomodasi"
                  onClick={() => navigate("/operasional-akomodasi")}
                />
              )}
              {/* Mini-app terpisah (mobile-first/PWA) di /akomodasi/ — berkas statis nginx,
                  bukan rute React Router, jadi pakai navigasi penuh. */}
              {otoritas.TOperationalMonitoring !== 0 && (
                <MenuIconCard
                  Icon={BiBuildingHouse}
                  label="Akomodasi (HP)"
                  onClick={() => window.location.assign("/akomodasi/")}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralAffairPage;
